import { startOfMonth } from "date-fns";

export const getMinFutureContractStartDate = (now: Date = new Date()): Date =>
	startOfMonth(now);
